import { AppointmentStatus } from '../api/types';

export const STATUS_LABELS: Record<AppointmentStatus, string> = {
  PENDING:         'Pending',
  CONFIRMED:       'Confirmed',
  CHECKED_IN:      'Checked In',
  IN_CONSULTATION: 'In Consultation',
  COMPLETED:       'Completed',
  CANCELLED:       'Cancelled',
  REJECTED:        'Rejected',
};

export function statusLabel(status: AppointmentStatus | string): string {
  return STATUS_LABELS[status as AppointmentStatus] ?? status;
}
